import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React__default, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import { Mitt, useEventCallback, Portal } from '@thimble/utility';
import { I as Icon } from '../Utilities-be7a8052.js';
import { N as NotificationSlot } from '../NotificationSlot-6250785d.js';
import { B as Button } from '../Button-03bb5f6a.js';
import { useUnmount } from 'react-use';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/helpers/extends';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/set-timeout';
import '@babel/runtime-corejs3/core-js-stable/object/assign';
import '../Collapse/index.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var remove = function remove(arr, cb) {
  var index = _findIndexInstanceProperty(arr).call(arr, cb);

  if (index !== -1) {
    var _context;

    return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_sliceInstanceProperty(arr).call(arr, 0, index)), _toConsumableArray(_sliceInstanceProperty(arr).call(arr, index + 1, arr.length)));
  }

  return arr;
};

var registry = [];
var DrawerMitt = Mitt();
DrawerMitt.on('REGISTER', function (id) {
  var _context2;

  return Drawer.registry = registry = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(registry), [id]);
});
DrawerMitt.on('UNREGISTER', function (id) {
  return Drawer.registry = registry = remove(registry, function (i) {
    return i === id;
  });
});
var uuid = 1;

var noop = function noop() {};

var notificationSlotPreprocess = function notificationSlotPreprocess(node) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "smb-drawer__body",
    style: {
      background: '#005d49',
      paddingBottom: 12,
      paddingTop: 12
    }
  }, node);
};

var Drawer = function Drawer(props) {
  var visible = props.visible,
      children = props.children,
      onClose = props.onClose,
      onEntered = props.onEntered,
      _props$header = props.header,
      header = _props$header === void 0 ? null : _props$header,
      notificationSlotRef = props.notificationSlotRef,
      contentClassName = props.contentClassName,
      contentStyle = props.contentStyle,
      _props$closeIconColor = props.closeIconColor,
      closeIconColor = _props$closeIconColor === void 0 ? 'dark-green' : _props$closeIconColor,
      placement = props.placement,
      __REGISTER__ = props.__REGISTER__,
      __RIGHT_SIDE_TIP_ON = props.__RIGHT_SIDE_TIP_ON;

  var _useState = useState(function () {
    return uuid++;
  }),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  useEffect(function () {
    if (__REGISTER__) {
      if (visible) {
        DrawerMitt.emit('REGISTER', id);
      } else {
        DrawerMitt.emit('UNREGISTER', id);
      }
    }
  }, [id, visible, __REGISTER__]);
  useUnmount(function () {
    DrawerMitt.emit('UNREGISTER', id);
  });
  var ecOnClose = useEventCallback(onClose || noop);
  useEffect(function () {
    if (__REGISTER__) {
      var cb = function cb(i) {
        if (i == id) ecOnClose();
      };

      DrawerMitt.on('REMOTE_CLOSE', cb);
      return function () {
        return DrawerMitt.off('REMOTE_CLOSE', cb);
      };
    }
  }, [ecOnClose, id, __REGISTER__]);
  return /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement(CSSTransition, {
    "in": visible,
    classNames: placement === 'left' ? 'smb-drawer--left' : 'smb-drawer--right',
    onEntered: onEntered,
    timeout: 500,
    unmountOnExit: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-drawer', placement === 'left' ? 'smb-drawer--left' : 'smb-drawer--right')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-drawer__mask",
    onClick: visible ? onClose : undefined
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-drawer__content', contentClassName),
    style: _objectSpread({
      right: __RIGHT_SIDE_TIP_ON ? 300 : undefined
    }, contentStyle)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-drawer__header"
  }, header, /*#__PURE__*/React__default.createElement(Button.Text, {
    className: "smb-drawer__close",
    onClick: visible ? onClose : undefined
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close",
    size: "small",
    color: closeIconColor
  }))), notificationSlotRef ? /*#__PURE__*/React__default.createElement(NotificationSlot, {
    transform: notificationSlotPreprocess,
    ref: notificationSlotRef
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-drawer__body"
  }, children)))));
};
/**
 * keep a div sticky to bottom like `shopping cart`
 * cannot detect whether it is Pinned, but we have:
 * @see https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
 * @see https://codepen.io/hey-nick/pen/mLpmMV
 * @see https://developers.google.com/web/updates/2017/09/sticky-headers
 */


var StickyToBottom = function StickyToBottom(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "smb-drawer__sticky-to-bottom"
  }, children);
};

Drawer.StickyToBottom = StickyToBottom;
Drawer.Mitt = DrawerMitt;
Drawer.registry = registry;

export default Drawer;
